import { useTranslation } from 'react-i18next';

export const keyPrefix = 'duplicate_user';
export const useDuplicateUserTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    toast_success: 'Дубликат пользователя успешно создан',
    toast_error: 'Не удалось создать дубликат пользователя',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    toast_success: 'Duplicate user created successfully',
    toast_error: 'Failed to create duplicate user',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    toast_success: 'Usuário duplicado criado com sucesso',
    toast_error: 'Falha ao criar usuário duplicado',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    toast_success: 'Usuario duplicado creado con éxito',
    toast_error: 'Error al crear el usuario duplicado',
  },
}) as Record<string, unknown>;
